import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ListItem } from "@skailer-com/uikit";

export function CustomFieldListItemDatetime({
  field,
  fieldValue,
  label,
}: CustomFieldListItemProps) {
  const { renderDateAndTime } = useFormatter();

  return (
    <ListItem
      preTitle={label ?? field.title}
      title={fieldValue?.datetime_value ? renderDateAndTime(fieldValue.datetime_value) : ""}
    />
  );
}
